import OptimizelyFeatureFlagProvider, {
  useGetOptimizelyFeatureFlagManager,
  useOptimizelyFeatureFlag,
} from 'v2/core/clients/featureFlag/optimizely';
import useOptimizelyFeatureVariable from 'v2/core/clients/featureFlag/optimizely/useOptimizelyFeatureVariable';
import {
  IFeatureFlagManager,
  IUseFeatureFlag,
} from 'v2/core/clients/featureFlag/types';

const FeatureFlagProvider = OptimizelyFeatureFlagProvider;

const useGetFeatureFlagManager: () => IFeatureFlagManager =
  useGetOptimizelyFeatureFlagManager;

const useFeatureFlag: IUseFeatureFlag = useOptimizelyFeatureFlag;
const useFeatureVariable = useOptimizelyFeatureVariable;

export {
  FeatureFlagProvider,
  useGetFeatureFlagManager,
  useFeatureFlag,
  useFeatureVariable,
};
